import React, { useCallback, useState } from "react";
import { Autocomplete } from "@mui/material";
import { RequestIdChipContainer, StyledChip, StyledTextField } from "./styles";

export const RequestIdChipInput = (props) => {
  const { onChange, ...rest } = props;
  const [values, setValues] = useState([]);

  const handleChange = useCallback(
    (_, newValue) => {
      setValues(newValue);
      if (onChange) {
        onChange(newValue);
      }
    },
    [onChange]
  );

  return (
    <RequestIdChipContainer>
      <div className="filter-label">By Request ID:</div>
      <Autocomplete
        multiple
        freeSolo
        options={[]}
        value={values}
        onChange={handleChange}
        renderTags={(value, getTagProps) => {
          return value.map((option, index) => (
            <StyledChip key={`${option}_${index}`} variant="outlined" label={option} {...getTagProps({ index })} />
          ));
        }}
        renderInput={(params) => (
          <StyledTextField {...params} variant="outlined" fullWidth placeholder="Add Request IDs" />
        )}
        {...rest}
      />
    </RequestIdChipContainer>
  );
};
